import moment from "moment-timezone";
import momentNotTz from "moment";
import { DEFAULT_TZ } from "../modules/schedule/types/schedule.types";

moment.tz.setDefault(DEFAULT_TZ);

export function GetStartAndEndOfCurrentWeek(format?: {
    start?: string;
    end?: string;
}) {
    const startOfWeek = moment()
        .startOf("isoWeek")
        .format(format?.start || "YYYY-MM-DD");

    const endOfWeek = moment()
        .endOf("isoWeek")
        .format(format?.end || "YYYY-MM-DD");

    return { startOfWeek, endOfWeek };
}

export default moment;
export { momentNotTz };
